import { useNavigate } from "@tanstack/react-router";
import { TabSwitcher } from "../../../ui/components/TabSwitcher";
import { useI18n } from "../../lib/i18n";

/**
 * Sessions and errors are separate routes/lists (different row schemas —
 * duration/replay-availability vs. message/stack/severity — forcing them
 * into one unified list would mean lots of nullable fields), sharing this
 * one tab strip so they still read as a single "Product Analytics" page.
 */
export function ProductAnalyticsTabs({ active }: { active: "sessions" | "errors" }) {
  const navigate = useNavigate();
  const { t } = useI18n();

  return (
    // The list pages' container is a column flexbox, whose default
    // align-items: stretch would otherwise stretch this to the full page
    // width even though TabSwitcher's own root is display: inline-flex.
    <div style={{ alignSelf: "flex-start", marginBottom: 16 }}>
      <TabSwitcher
        aria-label={t("pro.system.productAnalytics.tabsAria")}
        tabs={[
          { value: "sessions", label: t("pro.system.productAnalytics.tab.sessions") },
          { value: "errors", label: t("pro.system.productAnalytics.tab.errors") },
        ]}
        value={active}
        onChange={(v) => {
          void navigate({ to: `/system/product-analytics/${v}` });
        }}
      />
    </div>
  );
}
